import * as React from "react";
function SvgIcDoublearrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 16.62L15.01 12 12 7.38l.742-.38L16 12l-3.258 5-.742-.38zM8.742 17L12 12 8.742 7 8 7.38 11.01 12 8 16.62l.742.38z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcDoublearrow;
